import { action, observable } from 'mobx';
import { Store } from 'bernie-plugin-mobx';

import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { SerializedData } from 'bernie-core';

import { clearCustomPlacesFromStorage, loadCustomPlacesFromStorage, saveCustomPlacesInStorage } from './map-store-utils';

import { FeatureObject } from '@eg-maps/core';

export const CUSTOM_PLACES_KEY = 'custom_places';

interface CurrentHotelStoreDefaults {
  customPlaces: FeatureObject[];
}

export class MapStore extends Store {
  @observable
  public customPlaces?: FeatureObject[] | null;

  public id: number = Math.random();

  public isServerSide(): boolean {
    return typeof window === 'undefined'; // eslint-disable-line
  }

  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    if (!this.isServerSide()) {
      this.customPlaces = loadCustomPlacesFromStorage();
    }
  }

  public static DEFAULTS: CurrentHotelStoreDefaults = {
    customPlaces: [],
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public hydrate(data: SerializedData): void {
    // dont need to hydrate
  }

  @action
  public clearCustomPlaces() {
    this.customPlaces = MapStore.DEFAULTS.customPlaces;
    clearCustomPlacesFromStorage();
  }

  @action
  public addCustomPlace(customPlace: FeatureObject) {
    if (!this.customPlaces) {
      this.customPlaces = [];
    }
    this.customPlaces.push(customPlace);
    saveCustomPlacesInStorage(this.customPlaces);
  }

  @action
  public setCustomPlace(customPlace: FeatureObject) {
    if (customPlace) {
      this.customPlaces = [customPlace];
      saveCustomPlacesInStorage(this.customPlaces);
    } else {
      this.clearCustomPlaces();
    }
  }
}
